<template>
  <div>
    <transition name="fade" v-if="confirmAlert">
      <div class="alert-modal">
        <div class="alert-area">
            <div class="md:py-6  md:p-8 md:px-30 bg-white" id="alert_image_overlay">
              <div class="text-center pt-8 md:pt-0 login-selection-header pb-4">
                  Are you sure you want to <br class="md:hidden"/> delete this field? 
              </div>
              <div class="flex delete-confirm-alert-content sm:pb-8 lg:pb-0 w-full items-center justify-center">
                
                      <div class="flex pr-2">
                        <button @click="removeBrand()" class="new-app-btn bg-blue mt-6 sm:mt-0 pr-4">
                          Yes
                        </button>
                      </div>
                      <div class="flex pl-2 ">
                        <button @click="this.confirmAlert = false, this.removeBrandIndex = null" class="new-app-btn bg-theme mt-6 sm:mt-0 ">
                          No
                        </button>
                      </div>
                
              </div>
          </div>
        </div>
      </div>
    </transition>
    <div>
        <div class="apply-to-join pt-8 md:pt-0 text-paua text-3xl md:text-6xl lg2:text-title lg3:text-6xl md:tracking-tighter xl:tracking-tight font-semibold text-center lg2:leading-12 lg3:leading-13">
          Apply to join Buyhive
        </div>
        <div class="register-headline text-theme text-xl md:text-3xl lg2:text-2xl lg3:text-3xl font-medium text-center pt-1">
          You are registering as a freelance Sourcing Expert so buyers <br /> worldwide can hire you for sourcing projects!
        </div>
      </div>
  <div class="pt-8 pb-8 flex flex-wrap lg2:flex-nowrap">
    <div class="flex flex-col md:w-1/2 md:pt-24 lg2:w-auto lg2:flex-grow px-10 lg2:pl-0 lg2:pr-10 items-center">
      <img src="@/assets/images/register_image.png" class="mt-6 lg2:mt-10">
    </div>
    <div class="md:w-1/2">
      <div class="bg-theme-light px-4 pt-10 mt-8 lg2:mt-0 lg2:w-register-form rounded-lg">
        <Form @submit="onSubmit">
          <div class="flex flex-wrap w-full">
            <div class="lg:pr-2 w-full lg:w-1/2">
              <div>First Name<span class="text-error">*</span></div>
              <Field
                name="firstName"
                class="form-input"
                placeholder="e.g. John"
                :rules="isRequired"
                v-model="formData.first_name"
              />
              <div class="h-3 lg:h-2">
                <ErrorMessage name="firstName" class="form-error" />
              </div>
            </div>
            <div class="lg:pl-2 w-full lg:w-1/2">
              <div>Last Name<span class="text-error">*</span></div>
              <Field
                name="lastName"
                class="form-input"
                placeholder="e.g. Doe"
                :rules="isRequired"
                v-model="formData.last_name"
              />
              <div class="h-3 lg:h-5">
                <ErrorMessage name="lastName" class="form-error" />
              </div>
            </div>     
          </div>
          <div class="flex flex-wrap w-full">
            <div class="lg:pr-2 w-full lg:w-1/2">
              <div>
                Email <span class="text-xs">(Your Username)</span>
                <span class="text-error">*</span>
              </div>
              <Field
                name="email"
                class="form-input"
                placeholder="e.g. email@website.com"
                :rules="validateEmail"
                v-model="formData.email"
              />
              <div class="h-3 lg:h-5">
                <ErrorMessage name="email" class="form-error" />
              </div>
            </div>
            <div class="lg:pl-2 w-full lg:w-1/2">
              <div>Phone Number<span class="text-error">*</span></div>
              <VueTelInput
                mode="international"
                name="phone"
                ref="telInput"
                :value="phone"
                @input="onPhoneInput"
              />
              <div class="h-3 lg:h-5">
                <span
                  v-if="!phone && phoneError"
                  class="form-error"
                >This field is required.</span>
              </div> 
            </div>     
          </div>
          <div class="flex flex-wrap w-full">
            <div class="lg:pr-2 w-full lg:w-1/2">
              <div>WeChat ID</div>
              <Field
                v-model="formData.wechat_id"
                name="wechatId"
                class="form-input"
              />
              <div class="h-5" />
            </div>
            <div class="lg:pl-2 w-full lg:w-1/2">
              <div>Country/Region (your location)<span class="text-error">*</span></div>
              <CountrySelect
                v-model="formData.country"
                :country="formData.country"
                placeholder="Choose your Country/Region"
                class="form-input focus:text-opacity-100 country-select"
                :class="{'text-dark text-opacity-50': !formData.country}"
                ref="countrySelect"
                name="country"
              />
              <div class="h-3 lg:h-5">
                <span
                  v-if="!formData.country && countryError"
                  class="form-error"
                >This field is required.</span>
              </div>
            </div>     
          </div>
          <div class="flex flex-wrap w-full">
            <div class="lg:pr-2 w-full lg:w-1/2">
              <div>Password<span class="text-error">*</span></div>
              <Field
                name="password"
                type="password"
                placeholder="Password"
                class="form-input"
                :rules="isRequired"
                v-model="formData.password"
              />
              <div class="h-3 lg:h-5">
                <ErrorMessage name="password" class="form-error" />
              </div>
            </div>
            <div class="lg:pl-2 w-full lg:w-1/2">
              <div>Confirm Password<span class="text-error">*</span></div>
              <Field
                name="confirmPassword"
                type="password"
                class="form-input"
                placeholder="Confirm Password"
                :rules="isRequired"
                v-model="formData.password_confirmation"
              />
              <div class="h-3 lg:h-5">
                <ErrorMessage name="confirmPassword" class="form-error" />
              </div>
            </div>   
          </div>
          <div class="flex flex-wrap w-full items-end">
            <div class="lg:pr-2 w-full lg:w-1/2 cv-resume-experience">
              <div>
                CV/Resume Upload
                <span class="relative" 
                  @mouseenter="showFreelancerDetails = true"
                  @mouseleave="showFreelancerDetails = false"
                >
                  ⓘ
                  <div
                    v-if="showFreelancerDetails"
                    class="upload-cv-tooptip absolute z-20 -top-24 lg2:-top-12 lg2:left-5 -right-24 pt-4 px-3"
                  >
                    <div class="px-2 py-2 w-content text-xs font-normal border rounded-md bg-tooltip shadow-lg" style="font-size:11px; line-height: 14px;">
                      a) Please upload CV/Resume<br/>OR<br/>b) Copy & paste your LinkedIn Profile<br/> URL into a Word Document and upload
                    </div>
                  </div>
                </span>
                <span class="text-error">*</span>
              </div>
              <div class="text-xs">
                (Word, PDF, Jpeg, Png format only.Max file size 6MB)
              </div>
              <div class="form-input relative flex items-center">
                <Field
                  name="resume"
                  type="file"
                  class="absolute inset-0 opacity-0 z-10 w-full overflow-hidden"
                  :rules="fileRequired"
                  v-model="formData.cv"
                />
                <span
                  v-if="formData.cv && formData.cv[0]"
                  class="pointer-events-none absolute z-10 left-0 pl-4 w-10/12 truncate"
                >
                  {{ formData.cv[0].name }}
                </span>
                <span
                  v-else
                  class="pointer-events-none absolute text-sm z-10 left-0 px-2 opacity-50 tracking-tighter lg3:tracking-normal"
                >
                  Upload CV/Resume OR copy & paste your<br/> LinkedIn URL into a Word Doc & upload
                </span>
                <img src="@/assets/icons/upload.svg" class="ml-auto w-4-5 h-4-5">
              </div>
              <div class="h-3 lg:h-5">
                <ErrorMessage name="resume" class="form-error" />
              </div>
            </div>
            <div class="lg:pl-2 w-full lg:w-1/2">
              <div>Total Years of Sourcing Experience<span class="text-error">*</span></div>
              <Field
                name="totalExperience"
                as="select"
                class="form-input"
                v-model="formData.total_experience"
              >
                <option value disabled>Year(s)</option>
                <option
                  :key="`totalExperience-0`"
                  :value="0.5"
                ><span>Less than </span>1 Year</option>
                <option
                  v-for="(val) in 30"
                  :key="`totalExperience-${val}`"
                  :value="val"
                >{{ val }} Year<span v-if="val > 1">s</span></option>
                <option
                  :key="`totalExperience-31`"
                  :value="31"
                ><span>More than </span>30 Years</option>
              </Field>
              <div class="h-2 lg:h-5">
                <span
                  v-if="!formData.total_experience && totalExperienceError"
                  class="form-error"
                >
                  This field is required.
                </span>
              </div>
            </div>
          </div>
          <div class="flex flex-wrap w-full">
            <div class="w-full marketing-expertise-section" >
              <div style=""> 
                <span class="font-size:16px; line-height:22px"> Sourcing Market Expertise </span>
                <span class="text-error">*</span> 
                <span class="pt-1 text-xs hidden lg:inline">
                  (You <b><u>MUST</u></b> select at least <b><u>ONE</u></b> Country/Region <br class="md:hidden"> and can select up to 3)
                </span>
                <br class="md:hidden">
                <div class=" text-xs lg:hidden">
                  (You <b><u>MUST</u></b> select at least <b><u>ONE</u></b> Country/Region <br class="md:hidden"> and can select up to 3)
                </div>
              </div>
              <div class="sm:block marketing-expertise-content">
                <div class="pt-4 md:pt-4"></div>
                  <div class="text-sm">
                    Choose the country/region where you have the <br class="md:hidden"><b>most</b> sourcing experience.<span class="text-error">*</span>  <span class="text-xs"> (mandatory) </span>
                  </div>
                  <CountrySelect
                    v-model="formData.market_expertise_country_1"
                    :country="formData.market_expertise_country_1"
                    placeholder="Choose your Country/Region"
                    class="form-input focus:text-opacity-100 text-sm country-select market-expertise"
                    :class="{'text-dark text-opacity-50': !formData.country}"
                    ref="countrySelect"
                    name="country"
                  />
                  <div class="">
                    <span
                      v-if="!formData.market_expertise_country_1 && countryOpt1Error"
                      class="form-error"
                    >This field is required.</span>
                  </div>
                <div >
                  <div class="pt-4 text-sm md:pt-1">
                    Choose the country/region where you have the <br class="md:hidden"><b>second most</b>  sourcing experience. 
                    <span class="text-xs"> (optional) </span>
                  </div>
                  <CountrySelect
                    v-model="formData.market_expertise_country_2"
                    :country="formData.market_expertise_country_2"
                    placeholder="Choose your Country/Region"
                    class="form-input focus:text-opacity-100 text-sm country-select market-expertise"
                    :class="{'text-dark text-opacity-50': !formData.country}"
                    ref="countrySelect"
                    name="country"
                  />
                  <div class="">
                  </div>
                </div>
                <div >
                  <div class="pt-4 text-sm md:pt-1">
                    Choose the country/region where you have the <br class="md:hidden"><b>third most</b> sourcing experience. 
                    <span class="text-xs">(optional)</span>
                  </div>
                  <CountrySelect
                    v-model="formData.market_expertise_country_3"
                    :country="formData.market_expertise_country_3"
                    placeholder="Choose your Country/Region"
                    class="form-input focus:text-opacity-100 text-sm country-select market-expertise"
                    :class="{'text-dark text-opacity-50': !formData.country}"
                    ref="countrySelect"
                    name="country"
                  />
                </div>
                <div class="h-4 lg:h-8">
                  
                </div>
              </div>
            </div>
          </div>
          <div class=" tell-us-more-content text-center text-xs lg2:text-sm pb-5 tracking-tight">
            Tell us more about the sourcing work you have done and select your main product category, sub-category 
            & years of experience sourcing that product. Click
            <span class="inline-flex items-center">
               &nbsp;<a
                    class="flex justify-center items-center w-9 h-6 bg-dark-blue  text-white text-xs lg2:text-sm font-bold"
                    style="border-radius: 3px"
                  >Add</a> &nbsp;
            </span>
            after your selection.
          </div>
          <div>
            <div class="hidden lg:block">
              Product Category, Sub-Category & Years of Experience<span class="text-error">*</span>
              <span class="text-xs"> (Maximum 5)</span>
            </div>
            <div class="flex flex-wrap lg:flex-nowrap items-center">
              <div class="w-full lg:w-2/5 lg:pr-2">
                <p class="lg:hidden">
                  Product Category<span class="text-error">*</span>
                  <span class="text-xs"> (Maximum 5)</span>
                </p>
                <Field
                  name="category"
                  as="select"
                  class="form-input text-opacity-50 focus:text-opacity-100"
                  v-model="experience.category"
                  @change="updateExperienceValidation()"
                >
                  <option value disabled>Choose a Product Category</option>
                  <option
                    v-for="(cat, index) in getCategories"
                    :key="`categories-${index}`"
                    :value="cat.category_id_token"
                  >
                    {{ cat.category_name }}
                  </option>
                </Field>
                <div class="h-3 lg:hidden">
                  <span
                    v-if="!experiences.length && experienceError"
                    class="form-error"
                  >This field is required.</span>
                </div>
              </div>
              <div class="w-full lg:w-1/3 lg:pr-2">
                <p class="lg:hidden">
                  Sub-Category<span class="text-error">*</span>
                  <span class="text-xs"> (Maximum 5)</span>
                </p>
                <Field
                  name="subCategory"
                  as="select"
                  @change="updateExperienceValidation()"
                  class="form-input text-opacity-50 focus:text-opacity-100"
                  v-model="experience.subCategory"
                >
                  <option value disabled>Choose Sub-Category</option>
                  <template v-if="selectedCategory">
                    <option
                      v-for="(sub, index) in subCategories"
                      :key="`sub-category-${index}`"
                      :value="sub.sub_category_id"
                    >
                      {{ sub.sub_category_name }}
                    </option>
                  </template>
                  <template v-else>
                    <option value="1"></option>
                  </template>
                </Field>
                <div class="h-3 lg:hidden">
                  <span
                    v-if="experienceError"
                    class="form-error"
                  >This field is required.</span>
                </div>
              </div>
              <div class="w-full lg:w-1/5 lg:pr-2">
                <p class="lg:hidden">
                  Years of Experience<span class="text-error">*</span>
                  <span class="text-xs"> (Maximum 5)</span>
                </p>
                <div class="flex justify-between items-center">
                  <Field
                    name="years"
                    @change="updateExperienceValidation()"
                    as="select"
                    class="form-add-input mr-2 md:mr-0"
                    v-model="experience.years"
                  >
                    <option value disabled>Year(s)</option>
                    <option
                      :key="`experience-0`"
                      :value="0.5"
                    ><span>Less than </span>1 Year</option>
                    <option
                      v-for="(val) in 30"
                      :key="`experience-${val}`"
                      :value="val"
                    >{{ val }} Year<span v-if="val > 1">s</span></option>
                    <option
                      :key="`experience-31`"
                      :value="31"
                    ><span>More than </span>30 Years</option>
                  </Field>
                  <button
                    class="lg:hidden w-11 h-10 bg-dark-blue rounded-lg text-white text-sm font-bold"
                    type="button"
                    :disable="experiences.length > 4"
                    :class="{'opacity-50': experiences.length > 4}"
                    @click="addExperience"
                  >Add</button>
                </div>
              </div>
              <button
                class="hidden lg:inline-block w-11 h-10 rounded-lg bg-dark-blue text-white text-sm font-bold"
                type="button"
                :disable="experiences.length > 4"
                :class="{'opacity-50': experiences.length > 4}"
                @click="addExperience"
              >Add</button>
            </div>
            <div class="h-3 lg:h-5">
              <span
                v-if="!experiences.length && experienceError "
                class="form-error"
              >This field is required.</span>
            </div>
            <div class="flex flex-wrap">
              <div
                v-for="(exp, index) in experiences"
                :key="`selected-${index}`"
                class="text-xs pr-2 pb-2"
              >
                <div class="bg-green-b px-2 py-1">
                  <span class="pr-2">
                    {{exp.category.name}} - {{exp.subCategory.name}} - <span v-if="exp.years > 1 && exp.years < 31">{{exp.years}} Years</span> <span v-else-if="exp.years > 30">More than 30 Years</span><span v-else-if="exp.years < 1">Less than 1 Year</span><span v-else>1 Year</span>
                  </span>
                  <span
                    class="cursor-pointer text-xl"
                    @click="removeExperience(index)"
                  >x</span>
                </div>
              </div>
            </div>
          </div>
          <div class="company-section" >
            <div class="pt-4 md:pt-1">
              What famous brands/companies have you done sourcing for in your past jobs?<span class="text-error">*</span> 
              <br/>
              <span class="text-xs">(Please provide at least <b><u>ONE</u></b>.  You can provide up to 5)</span>
            </div>
            <div class="flex flex-wrap w-full pb-2 lg:pb-0" >
              <div class="lg:pr-2 w-full lg:w-1/2">
                <Field
                  name="brand"
                  class="form-input brand-add-input mr-2 md:mr-0"
                  @input="updateBrandText()"
                  placeholder="Type brand/company name"
                  v-model="brand"
                />
                <div class="h-3 lg:h-5">
                  <span
                    v-if="brandRequiredError"
                    class="form-error"
                  >This field is required.</span>
                  <span
                    v-if="characterLimitError"
                    class="form-error"
                  >Exceeds character limit of 50.</span>
                </div>
              </div>
              <div class="lg:pl-2 w-full lg:w-1/2 flex lg:items-start justify-center md:justify-start">
                <a
                  class="text-white cursor-pointer add-brand-btn py-3 lg:px-4 px-4 rounded-lg font-bold"
                  :class="isAddBrandDisabled ? 'bg-disabled-dark-blue' : 'bg-dark-blue'"
                  :disabled="isAddBrandDisabled"
                  @click="addBrand"
                >
                  Add another brand/company
                </a>
              </div>
            </div>
            <div
              v-for="(input, index) in brands"
              :key="index"
              class=" flex flex-wrap w-full lg:flex-nowrap">
              <div class="lg:pr-2 pb-2 w-90p lg:w-1/2">
                <input
                  :name="`brand${index}`"
                  class="form-input lg:w-80"
                  :id="`brand${index}`"
                  @input="updateBrandField(index)"
                  placeholder="Type brand/company name"
                  v-model="brands[index]"
                />
                <span
                    v-if="brandsCharacterLimitError[index]"
                    class="form-error"
                  >Exceeds character limit of 50</span>
              </div>
              <div class="lg:pr-2 lg:pb-2 lg:w-1/2 flex items-center">
                <div
                  class=" cursor-pointer  pl-2 lg:w-1/5"
                  @click="this.confirmAlert = true, this.removeBrandIndex = index">
                    <img src="@/assets/images/trash.png" class="">
                </div>
              </div>
            </div>
            <div class="pb-1 flex flex-wrap w-full lg:flex-nowrap">
              <span
                v-if="brandError"
                class="form-error lg:pr-2 w-4/5 lg:w-1/2">
                Atleast one field is required.
              </span>
            </div>
          </div>
          <div class="pt-5 inline-block">
            <div class="flex items-center">
              <input
                type="checkbox"
                class="w-6 h-6"
                v-model="checkbox"
              />
              <span class="pl-3 text-sm">
                I agree to  
                <a
                  :href="policyLink"
                  target="_blank"
                  class="underline text-green"
                >Privacy Policy</a>
              </span>
            </div>
            <div class="h-3 lg:h-5">
              <span
                v-if="!checkbox && checkboxError"
                class="form-error"
              >
                This field is required.
              </span>
            </div>
          </div>
          <div class="text-center pt-8 pb-6">
            <button
              class="bg-dark-blue text-white py-3 px-12 rounded-lg font-bold"
              @click="validateFields"
            >
              Register
            </button>
            <div class="pt-3 text-medium" style="line-height: 21.86px; font-weight: 400;">
              Already have an account?
              <a
                style="font-weight: 500;"
                class="text-teal cursor-pointer"
                @click="openLoginForm"
              >Sign In here!</a>
            </div>
          </div>
        </Form>
      </div>
      <div class="flex flex-wrap w-full justify-center">
          <div class="pt-8 text-medium text-center" style="font-size: 16px; line-height: 18.2px; font-weight: 600;">
              Do you want to register as <br class="md:hidden" /> a Buyer?
              <a
                style="font-weight: 500;"
                class="text-teal underline cursor-pointer"
                @click="redirectBuyerRegister"
              >Click here!</a>
            </div>
      </div>
    </div>   
  </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VeeValidate from '@/shared/mixins/VeeValidate'
import { VueTelInput } from 'vue3-tel-input'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import store from '@/store/index'

export default {
  name: 'Register',
  mixins: [VeeValidate],
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Sourcing Expert Registration'
    if (store.getters.isUserLoggedIn && store.getters.getUserAuthInfo.role !== 'buyer') {
      next({ name: 'EmailVerification' })
    }
    else if (store.getters.isUserLoggedIn && store.getters.getUserAuthInfo.role === 'buyer') {
      // next({ name: 'Home'})
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    }
    next()
  },
  data() {
    return {
      confirmAlert: false,
      formData: {},
      experiences: [],
      market_expertise: [],
      brands: [],
      brandsCharacterLimitError: [],
      brandsCharacterLimit: false,
      brand: '',
      phone: '',
      experience: {
        category: '',
        subCategory: '',
        years: ''
      },
      totalExperienceError: false,
      countryError: false,
      countryOpt1Error: false,
      experienceError: false,
      brandError: false,
      removeBrandIndex: null,
      brandRequiredError: false,
      characterLimitError: false,
      phoneError: false,
      checkboxError: false,
      checkbox: false,
      showFreelancerDetails: false,
      showSourcingMarketDetails: false,
      policyLink: process.env.VUE_APP_PRIVACY_POLICY,
      termsLink: process.env.VUE_APP_BUYER_TERMS,
      serverBaseUrl: process.env.VUE_APP_SERVER_BASE_URL,
      topCountries: ['VN','TH','MY','ID','IN','HK','CN']
    }
  },
  components: { VueTelInput },
  mounted() {
    if (!this.categories || !this.categories.length) this.fetchCategories()
    const telInput = this.$refs.telInput.$el
    telInput.getElementsByTagName('input')[0].placeholder = "e.g. 1234 5678"
    this.setTopCountries()    
  },
  watch: {
    selectedCategory() {
      this.experience.subCategory = ''
    }
  },
  computed: {
    ...mapGetters([
      'getCategories'
    ]),
    isAddBrandDisabled() {
      return this.brands.length >= 4
    },
    categories() {
      return this.getCategories.length ? this.getCategories : []
    },
    subCategories() {
      return this.selectedCategory ? this.selectedCategory.sub_categories : []
    },
    selectedCategory() {
      return this.categories.find(cat => cat.category_id_token === this.experience.category)
    },
    selectedSubCategory() {
      return this.subCategories.find(sub => sub.sub_category_id === this.experience.subCategory)
    },
    isValidExperience() {
      return !this.isDuplicateExperience && this.experience.category && this.experience.subCategory && this.experience.years
    },
    isDuplicateExperience() {
      return this.experiences.find(exp => (exp.category.id === this.experience.category) && (exp.subCategory.id === this.experience.subCategory))
    },
    brandToAdd() {
      return {
        brand: this.brand
      }
    },
    experienceToAdd() {
      return {
        category: {
          id: this.selectedCategory.category_id_token,
          name: this.selectedCategory.category_name
        },
        subCategory: {
          id: this.selectedSubCategory.sub_category_id,
          name: this.selectedSubCategory.sub_category_name
        },
        years: this.experience.years
      }
    },
    isCustomError() {
      return this.countryError || this.countryOpt1Error || this.experienceError || this.phoneError || this.checkboxError || this.totalExperienceError || this.brandError || this.brandRequiredError || this.characterLimitError || this.brandsCharacterLimit
    }
  },
  methods: {
    ...mapActions([
      'fetchCategories',
      'registerFreelancer',
      'openLoginModal',
      'LoginSelectionMode'
    ]),
    redirectBuyerRegister() {
      window.location = `${process.env.VUE_APP_SERVER_BASE_URL}${process.env.VUE_APP_BUYER_REGISTER}`
    },
    openLoginForm() {
      this.LoginSelectionMode('freelancer');
      this.$router.push({name: 'Login'})
    },
    updateExperienceValidation() {
      if(!this.experiences.length && (this.experience.category == '' || this.experience.subCategory == '' || this.experience.years == '')) {
        return this.experienceError = true
      } 
      return this.experienceError = false
    },
    getExperienceValidation() {
      if(this.experiences.length == false && (this.experience.category == '' || this.experience.subCategory == '' || this.experience.years == '')) {
        return true
      } 
      return false
    },
    setTopCountries() {
      const selectTags = this.$el.querySelectorAll('.country-select')
      for (const selectTag of selectTags) {
        const placeHolderTag = selectTag.firstChild
        const hk = selectTag.querySelector('[value="HK"]')
        hk.innerHTML = 'Hong Kong SAR'
        this.topCountries.forEach(country => {
          const countryTag = selectTag.querySelector(`[value=${country}`)
          placeHolderTag.after(countryTag)
        })
      }
    },
    onPhoneInput(phone, phoneObject) {
      if (phoneObject?.formatted) {
        this.phone = phoneObject.formatted
        this.formData.country_code = phoneObject.country.dialCode
      }
    },
    updateBrandField(index) {
      if(this.brands[index].length > 50) {
        this.brandsCharacterLimitError[index] = true
      } else {
        this.brandsCharacterLimitError[index] = false
      }
      if(this.brands[index] !== '') { 
        this.brandError = false
      } 
    },
    updateBrandText() {
      if(this.brand !== '') {
        this.brandRequiredError = false
        this.brandError = false
      }
      if(this.brand.length > 50) {
        this.characterLimitError = true
      } else {
        this.characterLimitError = false
      }
    },
    addExperience() {
      if (this.experiences.length < 5 && this.isValidExperience) {
        this.experiences.push(this.experienceToAdd)
        this.experience = {}
        this.experienceError = false
      }
    },
    addBrand() {
      if (this.brands.length < 4 && this.brand.length < 50) {
        this.brands = [...this.brands, this.brand]
        this.brandsCharacterLimitError.push(false)
        this.brand = ''
        this.brandRequiredError = false
        this.characterLimitError = false
      } else {
        if(this.brands.length < 4) {
          if(this.brand.length > 50) {
            this.characterLimitError = true
            this.brandRequiredError = false
          } else {
            this.characterLimitError = false
            this.brandRequiredError = true
          }
        }
      }
    },
    removeBrand() {
      if(this.removeBrandIndex != null) {
        let brand_id =  `brand${this.removeBrandIndex}`
        document.getElementById(brand_id).value = ''
        this.brands[this.removeBrandIndex] = '';
        this.brands.splice(this.removeBrandIndex, 1);
        this.brandsCharacterLimitError.splice(this.removeBrandIndex, 1);
        if(this.brands.length == 0) {
          this.brandError = false
        }
      }
      this.confirmAlert = false
      this.removeBrandIndex = null
    },
    removeExperience(index) {
      this.experiences.splice(index, 1)
    },
    validateFields() {
      this.countryError = !this.formData.country
      this.countryOpt1Error = this.validateMarketExpertise()
      this.brandError = this.validateBrandAtleastOne()
      this.phoneError = !this.phone
      this.checkboxError = !this.checkbox
      this.brandRequiredError = this.validateBrand()
      this.brandRequiredError = this.validateBrand()
      this.experienceError = this.getExperienceValidation()
      this.totalExperienceError = !this.formData.total_experience > 0
    },
    validateBrandAtleastOne() {
      this.brandError = true
      for(let i = 0; i < this.brands.length; i++)  {
        if(this.brands[i] != '') { 
          this.brandError = false
        }
      }
      if(this.brands.length == 0) {
        return false
      }
      return this.brandError;
    },
    validateBrand() {
      if(this.brands.length == 0 && this.brand === '') return true
      return false
    },
    validateMarketExpertise() {
      let is_invalid = true;
      if(this.formData.market_expertise_country_1 && this.formData.market_expertise_country_1 !== '') {
        is_invalid = false;
      }
      return is_invalid
    },
    async onSubmit() {
      // validation for brand text field
      if(this.brands.length !== 0) {
        this.characterLimitError = false
        for(let i = 0; i < this.brands.length; i++)  {
          if(this.brands[i].length > 50) { 
            this.brandsCharacterLimit = true
          }
        }
      }
      if(this.brands.length !== 0 && this.brand == '') {
        this.brandError = true
        for(let i = 0; i < this.brands.length; i++)  {
          if(this.brands[i] !== '') { 
            this.brandError = false
          }
        }
      }
      if(this.brand.length > 50) {
        this.characterLimitError = true        
      } else {
        this.characterLimitError = false
      }
      if(this.brand.length) {
        this.brandError = false
      } 
      // validation for brand text field
      if(this.brands.length == 0 && this.brand === '') {
        this.brandRequiredError = true
      }

      // validation for product category
      if(this.experiences.length == 0) {
        if(this.experience.category !== '' && this.experience.subCategory !== '' && this.experience.years !== '' ) {
          this.addExperience()
          this.experienceError = false
        } else{
          this.experienceError = true
        }
      }
      if(this.experiences.length !== 0) {
        if(this.experience.category !== '' && (this.experience.subCategory == '' && this.experience.years == '')) {
          this.experienceError = true
        } else if(this.experience.years !== '' && (this.experience.subCategory == '' && this.experience.category == '')){
          this.experienceError = true
        } else if(this.experience.subCategory !== '' && (this.experience.years == '' && this.experience.category == '')){
          this.experienceError = true
        } else if(this.experience.years !== '' && this.experience.subCategory !== '' && this.experience.category !== '') {
          this.addExperience()
          this.experienceError = false
        }
      }
      this.experienceError = this.getExperienceValidation();
      if (this.isCustomError) return
      if (this.phone.charAt(0) === '+') {
        this.phone = this.phone.slice(this.formData.country_code.length + 1, this.phone.length)
      }
      this.formData.phone_number = this.phone.replace(/[^0-9]/g, '')      
      const response = await this.registerFreelancer(this.formatFormData())
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
      localStorage.removeItem('previousUrl')
      if (response.result) this.$router.push('/email-verification')
    },
    formatFormData() {
      const userData = new FormData()
      Object.keys(this.formData).forEach(key => {
        if (key !== 'cv') userData.append(key, this.formData[key] || '')
      })
      userData.append('cv', this.formData.cv[0])

      this.experiences.forEach((exp, index) => {
        userData.append(`experience[${index}][sub_category]`, exp.subCategory.id)
        userData.append(`experience[${index}][years]`, exp.years)
      })
      let brand_total_count = this.brands.length;
      let brand_array = [];
      for(let i = 0; i < brand_total_count; i++)  {
        if(this.brands[i] !== '') {
          brand_array.push(this.brands[i])
        }
      } 
      if(this.brand !== ''){
        brand_array.push(this.brand) 
      } 
      userData.append(`brands`,brand_array);  
      userData.append(`market_expertise[0]`,this.formData.market_expertise_country_1);
      if(this.formData.market_expertise_country_2 !== undefined && this.formData.market_expertise_country_2 !== "" ) {
        userData.append(`market_expertise[1]`,this.formData.market_expertise_country_2);
      } else if(this.formData.market_expertise_country_3 !== undefined && this.formData.market_expertise_country_3 !== "") { 
        userData.append(`market_expertise[1]`,this.formData.market_expertise_country_3);
        return userData
      }

        if(this.formData.market_expertise_country_3 !== undefined && this.formData.market_expertise_country_3 !== "") { 
          userData.append(`market_expertise[2]`,this.formData.market_expertise_country_3);
        }
      return userData
    }
  }
};
</script>
<style lang="scss" scoped>
.login-selection-header {
    display: flex;
    justify-content: center;
    font-family: 'Avenir LT Pro';
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
}

.apply-to-join { 
  @media (min-width: 768px) {
    font-size: 60px;
    line-height: 81.96px;
    font-weight: 500;
    color: #201B57;
  }
  font-size: 40px;
  line-height: 48px;
  font-weight: 500;
}
.register-headline {
  @media (max-width: 768px) {
  line-height: 24px;
    font-weight: 500;
  }
}
.new-app-btn {
  @apply rounded-full px-4 py-2 text-white;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
}
.delete-confirm-alert-content {
  @media (max-width: 768px) {
    padding-bottom : 2rem;
  }
}
 .alert-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          content: "";
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
#alert_image_overlay {
  @media (max-width: 768px) {
    width: 80%;
  }
  margin: 1em auto;
  width: 70%;
  position: relative;
  color: #024457;
  z-index: 1001;
  border-radius: 8px;
}
::v-deep(.vue-tel-input) {
  @apply border-none w-full h-12 rounded-lg;
  .vti__dropdown {
    @apply bg-white w-22 rounded-lg mr-3;
  }
  .vti__input {
    @apply rounded-lg;
  }
  &:focus-within {
    box-shadow: none;
  }
}
.form-add-input {
  @apply border border-dark-b h-12 px-3 rounded-lg bg-white;
  width: calc(100% - 55px);
  @screen lg { @apply w-full; }
}

.brand-add-input {
  @apply border border-dark-b h-12 px-3 rounded-lg bg-white;
  @screen lg { @apply w-full; }
}
.country-tooltip {
  color: #000000;
  font-size: 11px;
  line-height: 14px;
  @media (max-width: 768px) {
    margin-top: 0.25rem;
    margin-right: -1.5rem;

  }
}
.market-expertise {
  @media (min-width: 1024px) {
    background-position:97.4%;
  }
}
.country-space-between {
  @media (max-width: 768px) {
    height: 2rem;
  }
}
.upload-cv-tooptip {
  font-size: 11px;
  line-height: 14px;
  @media (max-width: 768px) {
    margin-right: -0.5rem;
  
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
.cv-resume-experience {
  @media(min-width: 758px) {
    margin-top: -0.7rem;
  }
  @media(max-width: 758px) {
    margin-top: 0.3rem;
  }
}
.marketing-expertise-section {
  @media(min-width: 758px) {
    margin-top: -0.5rem;
  }
  @media(max-width: 758px) {
    padding-top: 0.55rem;
  }
}
.marketing-expertise-content {
  @media(min-width: 758px) {
    margin-top: -0.6rem;
  }
}
.tell-us-more-content {
  @media(min-width: 758px) {
    margin-top: -0.4rem;
  }
  @media(max-width: 758px) {
    // margin-top: 0.5rem;
  }
}
</style>
